import {GenericModel} from "../generic.model";
import {TransactionModel} from "./transaction/transaction.model";
import {makeModel} from "../../service/utils/utils.service";
import {CurrencyModel} from "./common/currency.model";
import {BookingModel} from "./booking/booking.model";
import {DictionaryModel} from "./dictionary/dictionary.model";
import {DataListModel} from "./dataList/dataList.model";
import {StationModel} from "./dataList/station/station.model";
import {LocationArrayModel} from "./dictionary/locationArray.model";
import {StationArrayModel} from "./dictionary/stationArray.model";

interface IXRef {
    xRef: string;
}

export class CarModel extends GenericModel {
    public booking: BookingModel;
    public currencyArray: CurrencyModel[];
    public dataList: DataListModel;
    public transaction: TransactionModel;
    public dictionary: DictionaryModel;
    public languageCode: string;
    public targetLanguageCode: string;

    protected fromJson(json?: any): boolean {
        this.booking = makeModel(json.booking, BookingModel);
        this.currencyArray = makeModel(json.currencyArray, CurrencyModel);
        this.dataList = makeModel(json.dataList, DataListModel);
        this.transaction = makeModel(json.transaction, TransactionModel);
        this.dictionary = makeModel(json.dictionary, DictionaryModel);
        this.languageCode = json.languageCode ?? null;
        this.targetLanguageCode = json.targetLanguageCode ?? null;
        return this.isValid();
    }

    protected isValid(): boolean {
        return this.booking !== null && this.dataList !== null;
    }

    public getStation(type: string): StationModel {
        const typeXRef: string = this.booking.vehicleRentalArray[0][type].xRef;
        const stationInLocation: StationArrayModel = this.findStationInLocationArrayDictionaryByXRef(typeXRef);
        return this.findStationInDataListByXRef(stationInLocation.xRef);
    }

    private findStationInLocationArrayDictionaryByXRef(xRef: string): StationArrayModel {
        return this.dictionary.locationArray
            .filter((locationItem: LocationArrayModel): boolean => Boolean(locationItem.stationArray?.length))
            .find((locationItem: LocationArrayModel): boolean => locationItem.xId === xRef)
            .stationArray[0];
    }

    private findStationInDataListByXRef(xRef: string): StationModel {
        return this.dataList.stationArray
            .find((stationItem: StationModel): boolean => stationItem.xId === xRef);
    }
}